"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _Label = _interopRequireDefault(require("./Label"));

var _validateInput = _interopRequireDefault(require("../validations/validateInput"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ColorInputAdornment = (0, _styledComponents.default)(_InputAdornment.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    &&{\n        [class^='MuiTypography-root']{\n            color: ", ";\n        }\n    }\n"])), function (props) {
  return props.theme.colors.grey300;
});

var NumberFormatInput = function NumberFormatInput(props) {
  var id = props.id,
      value = props.value,
      onChange = props.onChange,
      prefix = props.prefix,
      _props$customLabel = props.customLabel,
      customLabel = _props$customLabel === void 0 ? false : _props$customLabel,
      endAdornment = props.endAdornment,
      errorHandler = props.errorHandler,
      formattingOptions = props.formattingOptions,
      customPlaceholder = props.customPlaceholder,
      _props$handleKeyPress = props.handleKeyPress,
      handleKeyPress = _props$handleKeyPress === void 0 ? function () {} : _props$handleKeyPress,
      isFirstInput = props.isFirstInput,
      dependencies = props.dependencies,
      validationDependency = props.validationDependency,
      validations = props.validations,
      _props$errors = props.errors,
      errors = _props$errors === void 0 ? [] : _props$errors,
      noFocus = props.noFocus,
      options = props.options,
      minLength = props.minLength,
      maxLength = props.maxLength,
      regex = props.regex,
      regexError = props.regexError,
      postErrors = props.postErrors,
      postErrorHandler = props.postErrorHandler,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      fieldDescription = props.fieldDescription,
      labelTooltip = props.labelTooltip,
      t = props.t;
  var currency = options === null || options === void 0 ? void 0 : options.currency;
  var thousandSeparator = currency || (options === null || options === void 0 ? void 0 : options.formatted);
  var validationDepKey;
  var validationDepValue;

  if (validationDependency) {
    var _Object$values$;

    validationDepKey = Object.keys(validationDependency)[0];
    validationDepValue = (_Object$values$ = Object.values(validationDependency)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.toString();
  }

  var validationsArray = dependencies && dependencies[validationDepKey] && dependencies[validationDepKey][validationDepValue] ? [].concat(_toConsumableArray(dependencies[validationDepKey][validationDepValue]), _toConsumableArray(validations || [])) : validations;

  var inputChangeHandler = function inputChangeHandler(id, val) {
    if (postErrors) {
      postErrorHandler(id);
    }

    onChange(id, val);
  };

  (0, _react.useEffect)(function () {
    if (validationsArray) {
      inputValidation(value);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);
  (0, _react.useEffect)(function () {
    if (!validationsArray && !value && errors.length) errorHandler(_defineProperty({}, id, false)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validationsArray, value, validationDepValue]);
  (0, _react.useEffect)(function () {
    if (dependencies) {
      inputValidation(value);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [validationDepValue]);

  var inputValidation = function inputValidation(valueToCheck) {
    (0, _validateInput.default)({
      value: valueToCheck,
      validations: validationsArray,
      validationDependency: validationDepValue,
      errorHandler: errorHandler,
      id: id,
      minLength: minLength,
      maxLength: maxLength,
      regex: regex,
      regexError: regexError
    });
  };

  return _react.default.createElement(_react.default.Fragment, null, customLabel && _react.default.createElement(_Label.default, {
    customLabel: customLabel,
    tooltip: labelTooltip
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(_reactNumberFormat.default, {
    disabled: disabled,
    autoFocus: isFirstInput && !noFocus,
    placeholder: customPlaceholder,
    thousandSeparator: thousandSeparator,
    prefix: prefix,
    customInput: _Input.default,
    onValueChange: function onValueChange(e) {
      return inputChangeHandler(id, e.value);
    },
    value: value,
    onKeyDown: function onKeyDown(e) {
      return handleKeyPress && handleKeyPress(e);
    },
    endAdornment: currency ? _react.default.createElement(ColorInputAdornment, {
      position: "end"
    }, formattingOptions && formattingOptions.currency || '') : endAdornment
  }), _react.default.createElement(_Errors.default, {
    errors: postErrors ? [].concat(_toConsumableArray(errors), [postErrors.message]) : errors,
    t: t
  }));
};

var _default = _react.default.memo(NumberFormatInput, _isEqual.default);

exports.default = _default;